import React, { useState } from "react";

const LocationComponent = () => {
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);

  const getUserCoordinates = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setError(null); // Reset error on success
        },
        (error) => {
          setError(error.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const copyCoordinates = () => {
    if (location.latitude && location.longitude) {
      const coords = `Latitude: ${location.latitude}, Longitude: ${location.longitude}`;
      navigator.clipboard.writeText(coords)
        .then(() => setCopied(true))
        .catch(() => setCopied(false));

      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h2>User Location</h2>
      <button onClick={getUserCoordinates}>Get Location</button>

      {location.latitude && location.longitude ? (
        <div>
          <p>Latitude: {location.latitude}</p>
          <p>Longitude: {location.longitude}</p>
          <button onClick={copyCoordinates}>Copy Coordinates</button>
          {copied && <p style={{ color: "green" }}>Copied to clipboard!</p>}
        </div>
      ) : (
        <p>Click the button to get your location.</p>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default LocationComponent;
